import React from "react";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import ICatalog_Item from "@models/ICatalog_Item";
import INewOrder_Item from "@models/INewOrder_Item";
import { getPackItemPackCount, getPackItemTotalUnits } from "../../../services/CatalogItemService";

type Props = {
    orderItem?: INewOrder_Item;
    catalogItem?: ICatalog_Item;
};

export const PackQtyReverseViewer: React.FC<Props> = (props) => {
    const catalogItem = props.catalogItem;
    const qty = props.orderItem?.qty || 1;
    const packQty = catalogItem?.pack_qty || 1;

    return (
        <div className={"PackQtyReverseViewer text-small"}>
            {catalogItem && catalogItem.has_pack_qty && (
                <div>
                    <div>
                        <OwLabel title={"pack_qty"} isBold={true} className={"me-2"} postText={":"} />
                        {packQty}
                    </div>
                    <div className="d-flex">
                        <OwLabel title={"total_packs"} isBold={true} className={"me-2 no-wrap"} postText={":"} />
                        {getPackItemPackCount(catalogItem, qty)}
                    </div>
                    <div className="d-flex">
                        <OwLabel title={"total_units"} isBold={true} className={"me-2 no-wrap"} postText={":"} />
                        {getPackItemTotalUnits(catalogItem, qty)}
                    </div>
                </div>
            )}
        </div>
    );
};
